(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-default/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/themes/sport-default/assets/javascripts/init.js'); var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sportDefault = svs.themes.sportDefault || {};

  svs.themes.sportDefault.init = function(func, params) {
    var log = new svs.core.log.Logger('svs.themes.sportDefault.init');

    if (!_.isArray(params)) {
      params = [params];
    }

    if (typeof svs.themes.sportDefault[func] === 'function') {
      return svs.themes.sportDefault[func].apply(
        svs.themes.sportDefault,
        params
      );
    }
    log.debug('function ' + func + ' does not exist in this theme');
  };
})(svs);

 })(window);